import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
const SESSION_KEY = "tdf_ref_captured_code";

/** Referral codes are alnum, TDF-generated (7 chars) but admins can set a
 * custom one up to 32 chars — sanitise defensively before ever sending it
 * anywhere near the backend. */
export function sanitizeReferralCode(raw) {
  return (raw || "").toString().trim().toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 32);
}

/**
 * Fire the click-tracking beacon for a referral code (first-party cookie +
 * visit log are both set server-side). Safe to call repeatedly — skips the
 * network call if this exact code was already captured earlier in the same
 * browser session, so navigating around the site doesn't re-trigger it.
 */
export async function captureReferralClick(rawCode, landingPage) {
  const code = sanitizeReferralCode(rawCode);
  if (code.length < 3) return false;
  try {
    if (sessionStorage.getItem(SESSION_KEY) === code) return true;
  } catch {
    /* sessionStorage unavailable (privacy mode etc) — just keep going */
  }
  try {
    await axios.post(`${API}/referral/click`, {
      code,
      landing_page: (landingPage || "/").slice(0, 300),
    }, { withCredentials: true });
    try { sessionStorage.setItem(SESSION_KEY, code); } catch { /* ignore */ }
    return true;
  } catch {
    return false;
  }
}
